// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"94":"4840206a1ba5c5f3","888":"fbd8c41e6c1e089c"}[chunkId] + ".css";
};